import { createPing } from './ping/ping';
import { type JsonObject } from '../../models/event';

/**
 * Core events are reserved events, automatically tracked by PicoX’s SDKs,
 * which contains relevant information valuable to business units.
 *
 * The main core event is ping.
 *
 * In Web, a ping is sent when a new sessionStorage is created:
 * - When the page is loaded
 * - When a new tab is created
 * See full information here: https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
 */
export type CoreEvents = {
  start: () => void;
};

export const CoreEventType = {
  ping: 'ping_web',
} as const;

/**
 * Creates a live CoreEvents implementation
 *
 * @param track Function to track events
 * @returns A live CoreEvents implementation
 */
export function createCoreEvents(track: (name: string, payload: JsonObject) => void): CoreEvents {
  // Create Ping instance
  const ping = createPing(track);

  return {
    start: () => {
      // Attach Ping event handlers
      ping.start();
    },
  };
}
